/**
 * quitamos loader
 */
export function removePageLoader() {
  document.body.classList.remove('loading');
  document.querySelector('ewc-loader')?.remove();
}
